import { render } from "./Medical.vue?vue&type=template&id=581c2b26&scoped=true"
import script from "./Medical.vue?vue&type=script&lang=js"
export * from "./Medical.vue?vue&type=script&lang=js"

import "./Medical.vue?vue&type=style&index=0&id=581c2b26&lang=scss&scoped=true"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-581c2b26"]])

export default __exports__